import React from 'react';
import { HttpContext } from './context';
export var HttpProvider = function (_a) {
    var children = _a.children, client = _a.client;
    return (React.createElement(HttpContext.Provider, { value: { client: client } }, children));
};
//# sourceMappingURL=provider.js.map